// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"656":"fde43b20","721":"1690ee0a","898":"e8712da0","956":"478bc7be"}[chunkId] + ".chunk.css";
};